function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "copy",
  transform: "translate(-48.4 -0.75)"
}, React.createElement("g", {
  id: "Group_34137",
  "data-name": "Group 34137",
  transform: "translate(48.65 1)"
}, React.createElement("path", {
  id: "Path_63146",
  "data-name": "Path 63146",
  d: "M58.332,85.4H50.057a1.408,1.408,0,0,0-1.407,1.407V98.68a1.408,1.408,0,0,0,1.407,1.407h8.275a1.408,1.408,0,0,0,1.407-1.407V86.807A1.413,1.413,0,0,0,58.332,85.4Zm.419,13.276a.423.423,0,0,1-.423.423H50.053a.423.423,0,0,1-.423-.423V86.807a.423.423,0,0,1,.423-.423h8.275a.423.423,0,0,1,.423.423Z",
  transform: "translate(-48.65 -81.087)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.5
}), React.createElement("path", {
  id: "Path_63147",
  "data-name": "Path 63147",
  d: "M145.132,0h-8.275a1.408,1.408,0,0,0-1.407,1.407.492.492,0,0,0,.984,0,.423.423,0,0,1,.423-.423h8.275a.423.423,0,0,1,.423.423V13.28a.423.423,0,0,1-.423.423.492.492,0,1,0,0,.984,1.408,1.408,0,0,0,1.407-1.407V1.407A1.408,1.408,0,0,0,145.132,0Z",
  transform: "translate(-131.535)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.5
})));
var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 15.504,
    height: 19.5,
    viewBox: "0 0 15.504 19.5",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.c09c6a48.svg";
export { ForwardRef as ReactComponent };